<template>
  <div class="service_translation_controls">
    <b-select
      v-model="targetLanguage"
      size="is-small"
      class="service_translation_controls__select"
    >
      <option
        v-for="language in languages"
        :key="language.language_code"
        :value="language.language_code"
      >
        {{ language.language_code }}
      </option>
    </b-select>
    <BaseButton
      action="tercery"
      :loading="translating"
      size="medium"
      class="service_translation_controls__translate"
      @click="check"
    >
      <i slot="icon" class="is-flex">
        <IconTranslate class="icon is-small" />
      </i>
      <span slot="text">Translate</span>
    </BaseButton>
    <BaseButton
      v-if="translated && isAdmin"
      action="turquose-secondary"
      :loading="verifying"
      size="medium"
      class="service_translation_controls__translate"
      @click="verify"
    >
      <i slot="icon">
        <IconTranslate class="icon is-small" height="10" />
      </i>
      <span slot="text">Verify</span>
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/base-ui/BaseButton.vue";
import IconTranslate from "@/components/icons/IconTranslate.vue";
import { mapGetters } from "vuex";

export default {
  name: "TranslatorButton",
  components: { IconTranslate, BaseButton },
  props: {
    value: String,
    translate: Function,
    approve: Function,
    attributes: Array,
    isTranslated: Boolean,
  },
  data() {
    return {
      translating: false,
      verifying: false,
      translated: false,
    };
  },
  watch: {
    isTranslated: {
      immediate: true,
      handler(newVal) {
        this.translated = newVal;
      },
    },
  },
  computed: {
    ...mapGetters({
      languages: "language/getLanguages",
      isAdmin: "auth/isAdmin",
    }),
    targetLanguage: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    async check() {
      this.translating = true;
      await this.translate();
      this.translating = false;
      this.translated = true;
    },
    async verify() {
      this.verifying = true;
      await this.approve();
      this.verifying = false;
      this.translated = false;
    },
  },
};
</script>

<style scoped>
.service_translation_controls {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  float: right;
  margin-right: 0.75rem;
  margin-top: -0.25rem;
}
.service_translation_controls .field {
  margin-bottom: 0 !important;
}
.service_translation_controls__translate .icon-button {
  display: flex;
  align-items: center;
}
.service_translation_controls__translate svg {
  width: 1rem;
  height: 1rem;
}
</style>
